import React from 'react'
import { ContentHeader } from '../../../../../layout/Content'

function UnmovingProductsHeader() { return ( <ContentHeader title='Unmoving Products Report'/> ) }

export default React.memo(UnmovingProductsHeader)
